import React, { useCallback, useEffect } from 'react';
import {
    Row, Col,
} from '@commonsku/styles';
import { useHasUserFlag } from '../../../hooks';
import {
    PRESENTATION_BUILDER_AGENT_FLAG,
    SKUBOT_ENABLED,
} from '../../presentation-builder/PresentationBuilderPage';
import PresalesFields from './PresalesFields';
import BuildModeSelect, {
    BUILD_MODE_SKUBOT,
} from './presentation/BuildModeSelect';
import PresentationStyleSelect from './presentation/PresentationStyleSelect';
import PresentationTemplateSelect from './presentation/PresentationTemplateSelect';
import { PresentationStyle } from './presentation/types';

const PresentationFields = React.memo(({
    form,
    updateField,
}) => {
    const hasBuilderFlags = useHasUserFlag([PRESENTATION_BUILDER_AGENT_FLAG, SKUBOT_ENABLED]);
    const buildMode = form.build_mode || BUILD_MODE_SKUBOT;
    const isSkubotBuild = hasBuilderFlags && buildMode === BUILD_MODE_SKUBOT;

    useEffect(() => {
        if (isSkubotBuild && form.view_type !== PresentationStyle.TEMPLATE) {
            updateField('view_type', PresentationStyle.TEMPLATE);
        }
    }, [isSkubotBuild, form.view_type, updateField]);

    const handleBuildModeChange = useCallback((value) => {
        updateField('build_mode', value);
        if (value === BUILD_MODE_SKUBOT) {
            updateField('view_type', PresentationStyle.TEMPLATE);
        }
    }, [updateField]);

    return (
        <>
            <PresalesFields
                form={form}
                updateField={updateField}
            />
            {hasBuilderFlags && (
                <BuildModeSelect
                    value={buildMode}
                    onChange={handleBuildModeChange}
                />
            )}
            <Col xs padded>
                <Row style={{ gap: 23 }}>
                    {!isSkubotBuild && (
                        <Row style={{ width: '100%' }}>
                            <PresentationStyleSelect currentValue={form.view_type} onUpdateField={updateField} />
                        </Row>
                    )}
                    {(isSkubotBuild || form.view_type === PresentationStyle.TEMPLATE) && (
                        <Row style={{ width: '100%' }}>
                            <PresentationTemplateSelect
                                onUpdateField={updateField}
                                currentTemplateId={form.public_view_template_id}
                                currentLayoutId={form.public_view_layout_id}
                            />
                        </Row>
                    )}
                </Row>
            </Col>
        </>
    );
});

export default PresentationFields;
